import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FiChevronRight } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { setHistoryMetadata } from '../../state/actions';
import './HistoryMetaData.scss';

const HistoryMetaData = () => {
    const dispatch = useDispatch();
    const historyMetadata = useSelector(state => state.chat.historyMetadata);
    const [isHistoryExpanded, setIsHistoryExpanded] = useState(true);

    const toggleHistoryExpand = () => {
        setIsHistoryExpanded(!isHistoryExpanded);
    };

    const removeLabel = (labelToRemove) => {
        const newMetadata = historyMetadata.filter(label => label !== labelToRemove);
        dispatch(setHistoryMetadata(newMetadata));
    };

    if (!historyMetadata || historyMetadata.length === 0) {
        return null;
    }

    return (
        <div className="history-meta-data-component">
            <button
                type="button"
                className={`circular-button ${isHistoryExpanded ? 'expanded' : ''}`}
                onClick={toggleHistoryExpand}
            >
                <FiChevronRight />
            </button>
            <div className={`history-labels ${isHistoryExpanded ? 'expanded' : ''}`}>
                {historyMetadata.map((label, index) => (
                    <div key={index} className="label-chip">
                        <span>{label}</span>
                        <IoMdClose
                            className="remove-icon"
                            onClick={() => removeLabel(label)}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HistoryMetaData;
